// Lightweight, privacy-respecting visitor tracker.
// Sends one beacon per pathname change (skips admin routes).
import api from "@/lib/api";

const KEY = "kp_sess";

function sessionId() {
  try {
    let s = localStorage.getItem(KEY);
    if (!s) {
      s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(KEY, s);
    }
    return s;
  } catch {
    return "anon";
  }
}

let lastPath = null;
export function trackVisit(path) {
  if (!path || path.startsWith("/admin")) return;
  if (path === lastPath) return;
  lastPath = path;
  try {
    api.post("/track/visit", {
      session_id: sessionId(),
      path,
      referrer: (typeof document !== "undefined" ? document.referrer : "") || "",
    }).catch(() => {});
  } catch {
    // never break UX for analytics
  }
}
